import React from "react";
import FieldProto from "../../../../proto/field-proto";
import {PopoverParent} from "../../../../@types";
import ModelEntity from "../../../../../model2/model-entity";

// const debug = "FieldDepartment_PopoverMenuMore"
const debug = false

export type PopoverMenuMoreProps = {
    parent  : PopoverParent //
    field   : FieldProto
    model?  : ModelEntity
}

export default class FieldDepartment_PopoverMenuMore extends React.Component<PopoverMenuMoreProps> {

    onClick = ()=>{

        this.props.parent.hidePopover()

        gd.navigation.goTo('o/{0}/departments'.f(gd.companyId))
    }

    render() {

        debug && console.log(debug, "render()")

        if (!gd.ac.check.company.isManager()) return <div className="m-t-5"></div>

        return (
            <div className="help">
                <div className="flex-row-left-center" onClick={this.onClick}>
                    <div className="ui5-ico-15 i5-wrench m-r-8" />
                    <div className="ui5-txt-link-small-no-accent" >Edit departments</div>
                </div>
            </div>
        )
    }
}
